/* EP — packs Duo et « Un parfum pour chaque saison » sur la fiche produit (snippets/ep-bundle.liquid).
   Moteur commun : assets/ep-finder.js
   Choix des parfums : panneau qui s'ouvre (bas d'écran sur mobile, fenêtre centrée sur ordinateur),
   avec des fiches comme le moteur de recherche (inspiration, notes, genre, prix).
   Choix proposé par défaut : un best-seller (collection Parfums Populaires) parmi les parfums les plus proches ;
   dans le panneau, les best-sellers passent en premier.
   Prix affiché = remises Shopify « Packs » : le parfum le plus cher au prix normal, puis jusqu'à 3 autres
   (les moins chers) à -15 % (2 parfums : 1 remisé, 3 : 2, 4 et plus : 3 au maximum). Hors 50 ml. */
(function () {
var SHEET = null, LAST = null, MAXALT = 60;
function init(root) {
  if (!root || root.dataset.epbInit || !window.EPFinder) return;
  root.dataset.epbInit = '1';
  var E = window.EPFinder, EN = root.dataset.en === 'true';
  var T = EN ? {
    single: 'This perfume only', singleSub: 'Standard price',
    duo: 'Duo', duoSub: 'Your perfume + its perfect match',
    wr: 'A perfume for every season', wrSub: 'Spring · Summer · Autumn · Winter',
    yours: 'This perfume', pick: 'Our pick', close: 'Close',
    choose: { duo: 'Choose my duo' }, chooseS: { pri: 'Choose my spring perfume', ete: 'Choose my summer perfume', aut: 'Choose my autumn perfume', hiv: 'Choose my winter perfume' },
    sheetSub: { duo: 'Pick the perfume to pair with {n}', pri: 'The perfumes that suit spring best', ete: 'The perfumes that suit summer best', aut: 'The perfumes that suit autumn best', hiv: 'The perfumes that suit winter best' },
    add: { duo: 'Add the Duo', wr: 'Add my 4 perfumes' }, addOne: 'Add to cart',
    seasons: { pri: 'Spring', ete: 'Summer', aut: 'Autumn', hiv: 'Winter' },
    g: { Femme: 'Women', Homme: 'Men', Mixte: 'Unisex' },
    creation: 'Original', creationLine: 'An original creation by the house', adn: 'Same DNA', adnLine: 'Same DNA as ', res: 'Similar', resLine: 'Reminiscent of ', eq: 'Equivalent', eqLine: 'In the spirit of ',
    notes: 'See the notes', top: 'Top', heart: 'Heart', base: 'Base', allNotes: 'Notes',
    select: 'Choose', selected: 'Selected', view: 'View the product', best: 'Best-seller'
  } : {
    single: 'Le parfum seul', singleSub: 'Prix normal',
    duo: 'Duo', duoSub: 'Ton parfum + son accord parfait',
    wr: 'Un parfum pour chaque saison', wrSub: 'Printemps · Été · Automne · Hiver',
    yours: 'Ce parfum', pick: 'Notre sélection', close: 'Fermer',
    choose: { duo: 'Je choisis mon duo' }, chooseS: { pri: 'Je choisis mon parfum de printemps', ete: "Je choisis mon parfum d'été", aut: "Je choisis mon parfum d'automne", hiv: "Je choisis mon parfum d'hiver" },
    sheetSub: { duo: 'Choisis le parfum qui accompagnera {n}', pri: 'Les parfums qui vont le mieux au printemps', ete: "Les parfums qui vont le mieux à l'été", aut: "Les parfums qui vont le mieux à l'automne", hiv: "Les parfums qui vont le mieux à l'hiver" },
    add: { duo: 'Ajouter le Duo', wr: 'Ajouter mes 4 parfums' }, addOne: 'Ajouter au panier',
    seasons: { pri: 'Printemps', ete: 'Été', aut: 'Automne', hiv: 'Hiver' },
    g: { Femme: 'Femme', Homme: 'Homme', Mixte: 'Mixte' },
    creation: 'Création', creationLine: 'Création originale de la maison', adn: 'Même ADN', adnLine: 'Même ADN que ', res: 'Ressemblance', resLine: 'Rappelle ', eq: 'Équivalent', eqLine: 'Dans la lignée de ',
    notes: 'Voir les notes', top: 'Tête', heart: 'Cœur', base: 'Fond', allNotes: 'Notes',
    select: 'Choisir', selected: 'Sélectionné', view: 'Voir la fiche', best: 'Best-seller'
  };
  /* Remise Shopify « Packs » : -15 % sur les parfums après le plus cher, 3 parfums remisés au maximum */
  var RATE = 0.15, MAXD = 3;
  var SEAS = {
    pri: { floral: 1, fruite: .6, frais: .3 },
    ete: { frais: 1, aquatique: 1.1, fruite: .3 },
    aut: { boise: 1, epice: .8, oud: .3, gourmand: .2 },
    hiv: { ambre: 1, oud: .9, gourmand: .8, epice: .3 }
  };
  /* Best-sellers : ordre de la collection Parfums Populaires (1 = le plus populaire) */
  var POP = {};
  try { JSON.parse(root.dataset.pop || '[]').forEach(function (h, i) { if (!POP[h]) POP[h] = i + 1; }); } catch (err) {}
  function isPop(p) { return !!(POP[p.h] || p.pop); }
  function prank(p) { return POP[p.h] || (p.pop ? 999 : 1e9); }
  function byPop(a, b) { return prank(a) - prank(b); }
  function popFirst(list) { return list.filter(isPop).sort(byPop).concat(list.filter(function (p) { return !isPop(p); })); }
  var SKIPW = ['coffret', 'gift set', 'giftset', 'travel set', 'huile', 'miniature', 'decant', 'décant', 'testeur', 'tester', 'echantillon', 'échantillon'];
  function skipped(p) {
    var s = String((p.n || '') + ' ' + p.h).toLowerCase();
    if (SKIPW.some(function (w) { return s.indexOf(w) >= 0; })) return true;
    /* formats 50 / 25 / 20 ml exclus (mais pas 150 ml) */
    return ['50', '25', '20'].some(function (d) {
      for (var i = s.indexOf(d); i >= 0; i = s.indexOf(d, i + 1)) {
        var j = i + 2; if (s.charAt(j) === ' ' || s.charAt(j) === '-') j++;
        if ((i === 0 || '0123456789'.indexOf(s.charAt(i - 1)) < 0) && s.substr(j, 2) === 'ml') return true;
      }
      return false;
    });
  }
  var esc = E.esc, money = E.money, tn = E.tn || function (n) { return n; };
  var main = {
    h: root.dataset.handle, id: +root.dataset.variant, price: parseFloat(root.dataset.price),
    n: root.dataset.title, v: root.dataset.vendor, img: root.dataset.img || null, url: location.pathname
  };
  var state = { tier: root.dataset.default, sel: {} }, tiers = [];

  function sScore(p, s) { var w = SEAS[s], t = 0, k; for (k in w) t += (p.f[k] || 0) * w[k]; return t; }
  function seasonOf(p) { var best = 'aut', b = -1; Object.keys(SEAS).forEach(function (s) { var x = sScore(p, s); if (x > b) { b = x; best = s; } }); return best; }
  /* strict : un parfum mixte n'est associé qu'à des mixtes (repli sur tous les genres si la sélection est trop courte) */
  function genderOk(ref, p, strict) { if (!ref.g) return true; if (ref.g === 'Mixte') return !strict || p.g === 'Mixte'; return p.g === ref.g || p.g === 'Mixte'; }
  function eligible(ref, p, strict) {
    return p && !p.x && p.av && p.id && p.h !== ref.h && p.price != null &&
      p.f && Object.keys(p.f).length && genderOk(ref, p, strict) && !skipped(p);
  }
  function round2(x) { return Math.round(x * 100) / 100; }
  function short(n) { return String(n || '').split(' - ')[0]; }

  function build(db) {
    var ref = db.byH[main.h];
    if (!ref || !ref.f || !Object.keys(ref.f).length) return false;
    var sims = E.similarTo(db.P, ref, {}), simMap = {};
    sims.forEach(function (x) { simMap[x.p.h] = x.s; });
    function nearList(strict) { return sims.filter(function (x) { return eligible(ref, x.p, strict); }).map(function (x) { return x.p; }); }
    var near = nearList(true); if (near.length < 4) near = nearList(false);

    /* Duo : par défaut le best-seller le plus populaire parmi les 40 parfums les plus proches en notes */
    function duoSlot() {
      if (!near.length) return [];
      var pops = near.slice(0, 40).filter(isPop).sort(byPop);
      var cur = pops[0] || near[0];
      var rest = near.filter(function (q) { return q !== cur; }).slice(0, MAXALT - 1);
      return [{ tag: T.pick, cur: cur, alts: [cur].concat(popFirst(rest)) }];
    }

    /* « Un parfum pour chaque saison » : une saison par parfum, celle du parfum affiché étant déjà couverte */
    function wardrobe(strict) {
      var ms = seasonOf(ref), order = ['pri', 'ete', 'aut', 'hiv'], slots = [], used = {}; used[ref.h] = 1;
      var pool = db.P.filter(function (p) { return eligible(ref, p, strict); });
      order.filter(function (s) { return s !== ms; }).forEach(function (s) {
        var ranked = pool.map(function (p) {
          var all = 0; order.forEach(function (o) { all += sScore(p, o); });
          var raw = sScore(p, s), share = all ? raw / all : 0;
          return { p: p, share: share, sc: share * .55 + Math.min(1, raw) * .25 + (simMap[p.h] || 0) * .2 };
        }).filter(function (x) { return x.share >= .3; }).sort(function (a, b) { return b.sc - a.sc; }).map(function (x) { return x.p; });
        var cands = ranked.filter(function (p) { return !used[p.h]; });
        if (!cands.length) return;
        var pops = cands.slice(0, 40).filter(isPop).sort(byPop);
        var cur = pops[0] || cands[0];
        used[cur.h] = 1;
        var rest = cands.filter(function (q) { return q !== cur; }).slice(0, MAXALT - 1);
        slots.push({ season: s, tag: T.seasons[s], cur: cur, alts: [cur].concat(popFirst(rest)) });
      });
      return { ms: ms, slots: slots.length === 3 ? slots : null };
    }

    var duo = duoSlot(), wr = wardrobe(true);
    if (!wr.slots) wr = wardrobe(false);
    tiers.push({ k: 'single', name: T.single, sub: T.singleSub, slots: [] });
    if (duo.length === 1) tiers.push({ k: 'duo', name: T.duo, sub: T.duoSub, slots: duo });
    if (wr.slots) tiers.push({ k: 'wr', name: T.wr, sub: T.wrSub, slots: wr.slots, mainTag: T.seasons[wr.ms] });
    if (tiers.length < 2) return false;
    if (!tiers.some(function (t) { return t.k === state.tier; })) state.tier = tiers[1].k;
    return true;
  }

  function items(t) { return [main].concat(t.slots.map(function (s) { return s.cur; })); }
  /* Même calcul que Shopify : le plus cher reste au prix normal, les suivants (les moins chers d'abord,
     3 au maximum) ont -15 %, remise arrondie au centime inférieur par parfum */
  function totals(t) {
    var prices = items(t).map(function (p) { return p.price; }), full = 0, off = 0;
    prices.forEach(function (x) { full += x; });
    if (prices.length > 1) {
      var asc = prices.slice().sort(function (a, b) { return a - b; });
      for (var i = 0; i < Math.min(MAXD, prices.length - 1); i++) off += Math.floor(asc[i] * RATE * 100 + 1e-6) / 100;
    }
    var pay = round2(full - off);
    return { full: round2(full), pay: pay, save: round2(full - pay) };
  }
  function thumb(p, w) { w = w || 64; return p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">' : '<span class="epb-ph" aria-hidden="true">' + esc((p.n || '?').charAt(0)) + '</span>'; }

  /* Ligne « inspiration » comme dans le moteur de recherche */
  function insp(p, compact) {
    var tag, line;
    if (!p.i || p.l === 'c') { tag = T.creation; line = esc(T.creationLine); }
    else if (p.a) { tag = T.adn; line = esc(T.adnLine) + '<strong>' + esc(p.i) + '</strong>'; }
    else if (p.l === 'r') { tag = T.res; line = esc(T.resLine) + '<strong>' + esc(p.i) + '</strong>'; }
    else { tag = T.eq; line = esc(T.eqLine) + '<strong>' + esc(p.i) + '</strong>'; }
    if (compact) return (!p.i || p.l === 'c') ? '' : '<span class="epb-item__insp">' + line + '</span>';
    return '<div class="epb-card__insp"><span class="epb-tag' + ((!p.i || p.l === 'c' || p.a || p.l === 'r') ? ' epb-tag--muted' : '') + '">' + esc(tag) + '</span><span>' + line + '</span></div>';
  }
  function pyramid(p) {
    if (p.p) {
      var rows = [[T.top, 0], [T.heart, 1], [T.base, 2]].filter(function (x) { return p.p[x[1]] && p.p[x[1]].length; });
      if (!rows.length) return '';
      return '<dl class="epb-pyr">' + rows.map(function (x) { return '<dt>' + x[0] + '</dt><dd>' + esc(p.p[x[1]].map(tn).join(', ')) + '</dd>'; }).join('') + '</dl>';
    }
    if (p.nl && p.nl.length) return '<dl class="epb-pyr"><dt>' + T.allNotes + '</dt><dd>' + esc(p.nl.map(tn).join(', ')) + '</dd></dl>';
    return '';
  }

  function render() {
    root.querySelector('[data-epb-tiers]').innerHTML = tiers.map(function (t, ti) {
      var on = t.k === state.tier, tt = totals(t), r = tt.save > 0;
      var head = '<button type="button" class="epb-tier__btn" role="radio" aria-checked="' + on + '" data-epb-tier="' + t.k + '">' +
        '<span class="epb-radio" aria-hidden="true"></span>' +
        '<span><span class="epb-tier__name">' + esc(t.name) + '</span>' +
        '<span class="epb-tier__sub">' + esc(t.sub) + '</span></span>' +
        '<span class="epb-tier__price"><b>' + money(tt.pay) + '</b>' + (r ? '<s>' + money(tt.full) + '</s>' : '') + '</span></button>';
      var body = '';
      if (t.slots.length) {
        body = '<div class="epb-items">' +
          '<div class="epb-item">' + thumb(main, 48) + '<span><span class="epb-item__tag">' + esc(t.mainTag || T.yours) + '</span><span class="epb-item__name">' + esc(short(main.n)) + '</span><span class="epb-item__meta">' + esc(main.v) + ' · ' + money(main.price) + '</span></span></div>' +
          t.slots.map(function (s, si) {
            var p = s.cur, lbl = s.season ? T.chooseS[s.season] : T.choose[t.k];
            return '<div class="epb-item">' + thumb(p, 48) +
              '<span><span class="epb-item__tag">' + esc(s.tag) + '</span><a class="epb-item__name" href="' + esc(p.url) + '">' + esc(short(p.n)) + '</a><span class="epb-item__meta">' + esc(p.v) + ' · ' + money(p.price) + '</span>' + insp(p, true) + '</span>' +
              (altsOf(t, s).length > 1 ? '<button type="button" class="epb-swap" aria-haspopup="dialog" data-epb-swap="' + ti + ':' + si + '">' + esc(lbl) + ' <span aria-hidden="true">(' + altsOf(t, s).length + ')</span></button>' : '') +
              '</div>';
          }).join('') + '</div>';
      }
      return '<div class="epb-tier' + (on ? ' is-on' : '') + '">' + head + body + '</div>';
    }).join('');
    var cur = current(), tt = totals(cur), save = root.querySelector('[data-epb-save]');
    if (save) save.hidden = true;
    syncButton(cur, tt);
  }
  function altsOf(t, s) {
    var taken = t.slots.filter(function (o) { return o !== s; }).map(function (o) { return o.cur.h; });
    return s.alts.filter(function (a) { return taken.indexOf(a.h) < 0; });
  }
  function current() { for (var i = 0; i < tiers.length; i++) if (tiers[i].k === state.tier) return tiers[i]; return tiers[0]; }

  /* ——— Panneau de choix ——— */
  function sheet() {
    if (SHEET) return SHEET;
    var el = document.createElement('div');
    el.className = 'epb-sheet'; el.hidden = true;
    el.innerHTML = '<div class="epb-sheet__backdrop" data-epb-close></div>' +
      '<div class="epb-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="epbSheetTitle">' +
        '<div class="epb-sheet__grip" aria-hidden="true"></div>' +
        '<div class="epb-sheet__head"><div><p class="epb-sheet__kicker" data-epb-kicker></p><h2 class="epb-sheet__title" id="epbSheetTitle" data-epb-title></h2><p class="epb-sheet__sub" data-epb-sub></p></div>' +
        '<button type="button" class="epb-sheet__x" data-epb-close><svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<div class="epb-sheet__list" data-epb-list></div>' +
      '</div>';
    document.body.appendChild(el);
    SHEET = el;
    return el;
  }
  function openSheet(ti, si, trigger) {
    var t = tiers[ti], s = t.slots[si], el = sheet(), list = altsOf(t, s);
    el._ctx = { ti: ti, si: si, pick: pick };
    el.querySelector('[data-epb-kicker]').textContent = t.name;
    el.querySelector('[data-epb-title]').textContent = s.season ? T.chooseS[s.season] : T.choose[t.k];
    el.querySelector('[data-epb-sub]').textContent = s.season ? T.sheetSub[s.season] : T.sheetSub.duo.replace('{n}', short(main.n));
    el.querySelector('.epb-sheet__x').setAttribute('aria-label', T.close);
    el.querySelector('[data-epb-list]').innerHTML = list.map(function (p) {
      var cur = p.h === s.cur.h, g = T.g[p.g] || p.g || '', pyr = pyramid(p);
      return '<article class="epb-card' + (cur ? ' is-cur' : '') + '">' +
        '<a class="epb-card__media" href="' + esc(p.url) + '" target="_blank" rel="noopener" aria-label="' + esc(T.view + ' : ' + short(p.n)) + '">' + thumb(p, 160) + '</a>' +
        '<div class="epb-card__body">' +
          '<div class="epb-card__vendor">' + esc(p.v) + (g ? ' · ' + esc(g) : '') + '</div>' +
          '<div class="epb-card__name">' + esc(short(p.n)) + '</div>' +
          insp(p) +
          (pyr ? '<details class="epb-card__notes"><summary>' + T.notes + '</summary>' + pyr + '</details>' : '') +
          '<div class="epb-card__foot"><span class="epb-card__price">' + money(p.price) + (p.cp ? ' <s>' + money(p.cp) + '</s>' : '') + '</span>' +
          '<button type="button" class="epb-choose" data-epb-choose="' + esc(p.h) + '"' + (cur ? ' aria-pressed="true"' : '') + '>' + (cur ? '✓ ' + esc(T.selected) : esc(T.select)) + '</button></div>' +
        '</div></article>';
    }).join('');
    LAST = trigger || null;
    el.hidden = false;
    document.documentElement.classList.add('epb-lock');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    el.querySelector('[data-epb-list]').scrollTop = 0;
    setTimeout(function () { var x = el.querySelector('.epb-sheet__x'); if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function pick(ti, si, h) {
    var slot = tiers[ti].slots[si];
    for (var i = 0; i < slot.alts.length; i++) if (slot.alts[i].h === h) slot.cur = slot.alts[i];
    render();
  }

  /* Bouton « Ajouter au panier » du thème : il ajoute le pack quand un pack est choisi */
  var section = root.closest('section, .shopify-section') || document;
  var form = section.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
  var btn = form && form.querySelector('[name="add"]'), label = btn && btn.querySelector('span');
  var originalLabel = label ? label.textContent.trim() : T.addOne;
  function syncButton(t, tt) {
    var on = t.slots.length > 0;
    document.documentElement.classList.toggle('ep-bundle-on', on);
    if (label) label.textContent = on ? T.add[t.k] + ' · ' + money(tt.pay) : originalLabel;
  }
  if (form) document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var t = current(); if (!t.slots.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pack = t.name;
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items(t).map(function (p) { return { id: p.id, quantity: 1, properties: { _ep_pack: pack } }; }) })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Erreur'); return j; }); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        if (!document.querySelector('cart-drawer')) window.location.href = rootUrl + 'cart';
      })
      .catch(function (err) { alert(err.message || 'Erreur'); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('loading'); } });
  }, true);

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-epb-tier]');
    if (t) { state.tier = t.getAttribute('data-epb-tier'); render(); return; }
    var s = e.target.closest('[data-epb-swap]');
    if (s) { var a = s.getAttribute('data-epb-swap').split(':'); openSheet(+a[0], +a[1], s); }
  });

  E.load({ dataUrl: root.dataset.dataUrl, liveUrl: root.dataset.liveUrl, notesUrl: root.dataset.notesUrl }).then(function (db) {
    var live = db.byH[main.h]; if (live) { main.img = main.img || live.img; }
    if (!build(db)) return;
    root.hidden = false; render();
  }).catch(function () {});

}

/* Fermeture / choix dans le panneau (un seul panneau partagé) */
function closeSheet() {
  if (!SHEET || SHEET.hidden) return;
  SHEET.classList.remove('is-open');
  document.documentElement.classList.remove('epb-lock');
  var el = SHEET, trig = LAST;
  setTimeout(function () { el.hidden = true; }, 260);
  if (trig && document.body.contains(trig)) trig.focus({ preventScroll: true });
}
document.addEventListener('click', function (e) {
  if (!SHEET || SHEET.hidden) return;
  if (e.target.closest('[data-epb-close]')) { closeSheet(); return; }
  var c = e.target.closest('[data-epb-choose]');
  if (c && SHEET._ctx) {
    var ctx = SHEET._ctx; ctx.pick(ctx.ti, ctx.si, c.getAttribute('data-epb-choose'));
    closeSheet();
  }
});
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

function boot() { document.querySelectorAll('.ep-bundle').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();